import React from 'react'

const Photobooths = () => {
  const booths = [
    {
      name: "360° Video Booth",
      desc: "Cinematic slow-motion videos from every angle",
      icon: "fa-sync-alt",
      gradient: "from-[#1abc9c] to-[#16a085]",
      badge: "🔥 Most Popular",
      badgeStyle: "",
      features: [
        "360-degree revolving camera platform",
        "HD slow-motion video recording",
        "Instant social media sharing",
        "Custom overlays & branding",
        "LED ring lights & effects"
      ]
    },
    {
      name: "Overhead 360° Video Booth",
      desc: "Bird's eye view rotating camera magic",
      icon: "fa-circle-notch",
      gradient: "from-[#f093fb] to-[#f5576c]",
      badge: "✨ Premium",
      badgeStyle: "background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      features: [
        "Unique overhead rotating arm",
        "4K video quality",
        "Professional studio lighting",
        "Perfect for brand activation"
      ]
    },
    {
      name: "AI Photobooth",
      desc: "Transform into anything with AI magic",
      icon: "fa-robot",
      gradient: "from-[#667eea] to-[#764ba2]",
      badge: "🤖 AI Powered",
      badgeStyle: "background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      features: [
        "AI Doll transformation",
        "AI Face Swap",
        "Custom AI themes",
        "Vintage, superhero, any theme!"
      ]
    },
    {
      name: "iPad Photobooth",
      desc: "Sleek, portable photo experience",
      icon: "fab fa-apple",
      gradient: "from-[#4facfe] to-[#00f2fe]",
      features: [
        "Modern tablet interface",
        "Instant print & share",
        "Multiple filter options",
        "Email & SMS delivery"
      ]
    },
    {
      name: "Greenscreen Photobooth",
      desc: "Transport to any background",
      icon: "fa-fill-drip",
      gradient: "from-[#43e97b] to-[#38f9d7]",
      features: [
        "Custom virtual backgrounds",
        "Professional chroma key",
        "Unlimited creative possibilities",
        "Instant photo compositing"
      ]
    },
    {
      name: "Magic Mirror Photobooth",
      desc: "Interactive touchscreen mirror",
      icon: "fa-mirror",
      gradient: "from-[#fa709a] to-[#fee140]",
      features: [
        "Full-length interactive mirror",
        "Touchscreen animations",
        "Digital signatures & drawings",
        "Elegant party centerpiece"
      ]
    },
    {
      name: "Vintage Smile Photobooth",
      desc: "Classic retro photo experience",
      icon: "fa-camera-retro",
      gradient: "from-[#ee5a24] to-[#ff6b6b]",
      features: [
        "Nostalgic vintage aesthetics",
        "Sepia & black/white filters",
        "Retro print layouts"
      ]
    },
    {
      name: "Strip Photobooth",
      desc: "Classic photo strip memories",
      icon: "fa-film",
      gradient: "from-[#f093fb] to-[#f5576c]",
      features: [
        "4-photo strip format",
        "Multiple pose countdowns",
        "Perfect keepsake size"
      ]
    },
    {
      name: "Instagram Photobooth",
      desc: "Social media ready photos",
      icon: "fab fa-instagram",
      gradient: "from-[#833ab4] via-[#fd1d1d] to-[#fcb045]",
      features: [
        "Instagram logo & effects",
        "Instant social uploads",
        "Custom hashtag integration"
      ]
    }
  ]

  return (
    <section id="photobooths" className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6">
              📸 Premium Photobooths & Videobooths
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Capture unforgettable moments with our cutting-edge photo and video booth technology, designed to create lasting memories and instant entertainment.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {booths.map((booth, index) => (
              <article key={index} className="card p-6">
                {booth.badge && (
                  <div className="premium-badge" style={booth.badgeStyle ? { background: booth.badgeStyle } : {}}>
                    {booth.badge}
                  </div>
                )}
                <div className="text-center mb-4">
                  <div className={`w-20 h-20 mx-auto mb-4 bg-gradient-to-r ${booth.gradient} rounded-full flex items-center justify-center`}>
                    <i className={`${booth.icon.startsWith('fab') ? booth.icon : 'fas ' + booth.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-2xl font-bold mb-2 text-gray-800">
                    {booth.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    {booth.desc}
                  </p>
                </div>
                <ul className="space-y-2 text-gray-700 text-sm">
                  {booth.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className={`fas fa-check mt-1 mr-2`} style={{ color: booth.gradient.includes('1abc9c') ? '#1abc9c' : '#667eea' }}></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <div className="text-center mt-12 p-6 bg-white/20 rounded-2xl">
            <p className="text-white text-lg mb-4">
              <strong>All photobooths include:</strong> Instant prints, digital copies, custom branding, props, backdrop options, professional operator, and social media sharing capabilities.
            </p>
            <a
              href="https://wa.me/919444848616"
              className="premium-btn text-lg px-10 py-5 inline-flex items-center justify-center gap-3"
              style={{ background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)" }}
            >
              <i className="fab fa-whatsapp text-xl"></i>
              <span>Book Your Photobooth Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Photobooths
